import {
  OmsCustomerTagConditionStep,
  OmsFraudRiskConditionStep,
  OmsOrderTagConditionStep,
  OmsProductNameConditionStep,
  OmsProductTagConditionStep,
  OmsProductTypeConditionStep,
  OmsSelectedShippingConditionStep,
  OmsShipmentTagConditionStep,
  OmsSkuConditionStep,
  OmsVariantTitleConditionStep,
  OmsVendorConditionStep,
} from "@redotech/redo-model/advanced-flow/oms/conditions";
import { OmsConditionStep } from "@redotech/redo-model/advanced-flow/steps";
import { memo } from "react";
import { DeepPartial } from "..";
import { ListToListMatchTypeSelect } from "../common/list-to-list-match-type-select";

export const OmsListToListMatchTypeSelect = memo(
  function OmsListToListMatchTypeSelect({
    step,
    setStep,
    fieldLabelIsPlural,
  }: {
    step:
      | DeepPartial<OmsOrderTagConditionStep>
      | DeepPartial<OmsCustomerTagConditionStep>
      | DeepPartial<OmsSkuConditionStep>
      | DeepPartial<OmsSelectedShippingConditionStep>
      | DeepPartial<OmsProductNameConditionStep>
      | DeepPartial<OmsVariantTitleConditionStep>
      | DeepPartial<OmsProductTypeConditionStep>
      | DeepPartial<OmsProductTagConditionStep>
      | DeepPartial<OmsFraudRiskConditionStep>
      | DeepPartial<OmsShipmentTagConditionStep>
      | DeepPartial<OmsVendorConditionStep>;
    setStep: (step: DeepPartial<OmsConditionStep>) => void;
    fieldLabelIsPlural: boolean;
  }) {
    return (
      <ListToListMatchTypeSelect
        fieldLabelIsPlural={fieldLabelIsPlural}
        matchType={step.matchType}
        onMatchTypeChange={(matchType) => {
          setStep({
            ...step,
            matchType,
            requireExactMatch: step.requireExactMatch ?? true, // default to true
          });
        }}
      />
    );
  },
);
